import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Layout from './components/Layout';
import Home from './pages/Home';
import Contact from './pages/Contact';
import './index.css';
import './fonts.css';
import Biography from './pages/Biography';
import CheckoutPage from './pages/checkout/page';
import BookDetail from './pages/BookDetail';
import GloryHour from './pages/GloryHour';
import LoginPage from './pages/(auth)/login';
import SignupPage from './pages/(auth)/signup';
import WomenTransform from './pages/WomenTransform';

function App() {
  const isDev = process.env.NODE_ENV === "development";
  return isDev ? <React_App /> : <WordPress_App />;
}

function useCurrentPageSlug() {
  const location = useLocation();
  return location.pathname.replace(/^\/|\/$/g, "");
}


function WordPress_App() {
  const currentPageSlug = window.wpData?.slug || "home"; // Default to "home" if no slug is found

  let ComponentToRender;
  switch (currentPageSlug) {
    case 'home':
      ComponentToRender = <Home />;
      break;
    case "login_":
      ComponentToRender = <LoginPage />;
      break;
    case "signup":
      ComponentToRender = <SignupPage />;
      break;
    case 'checkout':
      ComponentToRender = <CheckoutPage />;
      break;
    case 'about':
      ComponentToRender = <Biography />;
      break;
    case 'biography':
      ComponentToRender = <Biography />;
      break;
    case 'contact':
      ComponentToRender = <Contact />;
      break;
    case "glory-hour":
      ComponentToRender = <GloryHour />;
      break;
    case "women-transform":
      ComponentToRender = <WomenTransform />;
      break;
    case "book-detail":
      ComponentToRender = <BookDetail />
      break;

    default:
      ComponentToRender = <Home />;
  }

  return <Layout currentPageSlug={currentPageSlug}>{ComponentToRender}</Layout>;
}

function React_App() {
  return (
    <Router>
      <React_App_Layout />
    </Router>
  );
}

function React_App_Layout() {
  const currentPageSlug = useCurrentPageSlug();

  return (
    <Layout currentPageSlug={currentPageSlug}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/about" element={<Biography />} />
        <Route path="/biography" element={<Biography />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/glory-hour" element={<GloryHour />} />
        <Route path="/women-transform" element={<WomenTransform />} />
        <Route path='/book-detail' element={<BookDetail />} />
      </Routes>
    </Layout>
  );
}


// ReactDOM.render(<App />, document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
